import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-12 border-t border-white/5" data-id="element-15">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-16">
          <p className="text-gray-600 text-sm" data-id="element-17">
            © {new Date().getFullYear()} The Viral PDF Lab. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-18">
            <button onClick={() => setPrivacyOpen(true)} className="text-gray-500 hover:text-primary text-sm transition-colors" data-id="element-19">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-20">·</span>
            <button onClick={() => setTermsOpen(true)} className="text-gray-500 hover:text-primary text-sm transition-colors" data-id="element-21">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-22">
        <p className="text-white font-medium" data-id="element-23">
          Última actualización: Febrero 2026
        </p>
        <p data-id="element-24">
          En The Viral PDF Lab, respetamos tu privacidad. Esta política describe
          cómo recopilamos, usamos y protegemos tu información personal.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-25">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-26">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. Los
          datos de pago son procesados de forma segura por nuestro proveedor de
          pagos y no se almacenan en nuestros servidores.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-27">2. Uso de la Información</h3>
        <p data-id="element-28">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido, enviar confirmaciones de compra y comunicaciones
          relacionadas con tu pedido.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-29">3. Protección de Datos</h3>
        <p data-id="element-30">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-31">4. Terceros</h3>
        <p data-id="element-32">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios necesarios para procesar
          tu compra.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-33">5. Cookies</h3>
        <p data-id="element-34">
          Utilizamos cookies esenciales para el funcionamiento del sitio. No
          utilizamos cookies de seguimiento publicitario.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-35">6. Tus Derechos</h3>
        <p data-id="element-36">
          Puedes solicitar acceso, corrección o eliminación de tus datos
          personales en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-37">
        <p className="text-white font-medium" data-id="element-38">
          Última actualización: Febrero 2026
        </p>
        <p data-id="element-39">
          Al adquirir cualquier producto de The Viral PDF Lab, aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-40">1. Producto Digital</h3>
        <p data-id="element-41">
          AI Clientes en 7 Días es un producto digital en formato PDF con
          recursos complementarios. El acceso se otorga inmediatamente después
          de la compra mediante descarga directa.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-42">2. Uso Personal</h3>
        <p data-id="element-43">
          El producto es para uso personal y no comercial. Queda prohibida la
          redistribución, reventa, copia o compartición del material sin
          autorización expresa.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-44">3. Resultados</h3>
        <p data-id="element-45">
          Los resultados dependen enteramente de la ejecución individual. No
          garantizamos ingresos específicos ni resultados financieros. Los
          ejemplos mencionados son ilustrativos.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-46">4. Política de Reembolso</h3>
        <p data-id="element-47">
          Debido a la naturaleza digital del producto, todas las ventas son
          finales. No se ofrecen reembolsos una vez entregado el acceso al
          material.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-48">5. Propiedad Intelectual</h3>
        <p data-id="element-49">
          Todo el contenido, plantillas, guiones y materiales incluidos son
          propiedad intelectual de The Viral PDF Lab y están protegidos por las
          leyes de derechos de autor.
        </p>
        <h3 className="text-white font-bold mt-4" data-id="element-50">6. Modificaciones</h3>
        <p data-id="element-51">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas al momento de su
          publicación.
        </p>
      </Modal>
    </>;
}